import type { TourFrame, TourStep } from '@carboncopyco/types';
import type { FramesWarnings } from '../types/frames';
import type { StepWarning } from '../types/step';

export const getStepWarningActive = (
  framesWarnings: FramesWarnings,
  frameId: TourFrame['id'],
  stepId: TourStep['stepId'],
  warning: StepWarning
) => {
  return (
    framesWarnings?.[frameId]?.[stepId]?.some((warn) => warn === warning) ||
    false
  );
};
